module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-1000-Classes-Active-80fe0fbf877a31f0076146c4d34f44c9.png";